/* eslint-disable import/prefer-default-export */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const newsHeaders = {
  'x-rapidapi-host': 'news-api14.p.rapidapi.com',
  'x-rapidapi-key': '88d917f3c6msh95cc9a230a1471ep10e85fjsn92331061dd5f',
};

const baseUrl = 'https://news-api14.p.rapidapi.com';
const createRequest = (url) => ({ url, headers: newsHeaders });

export const newsApi = createApi({
  reducerPath: 'newsApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getNews: builder.query({
      query: ({ newsCategory, count }) => createRequest(`/v2/search/articles?query=${newsCategory}&language=en&limit=${count}`),
    }),
  }),
});

export const {
  useGetNewsQuery,
} = newsApi;
